import {
  madridDateAddDays,
  madridFirstOfMonth,
  madridMonday,
  madridToday,
} from '@/utils/madrid-date';

export type EarningsPeriod = 'day' | 'week' | 'month' | 'all';

export function getMonday(): string {
  return madridMonday();
}

export function getPeriodRange(period: EarningsPeriod): {
  from: string;
  to: string;
} {
  const today = madridToday();
  if (period === 'day') return { from: today, to: today };
  if (period === 'week') return { from: getMonday(), to: today };
  if (period === 'month') return { from: madridFirstOfMonth(), to: today };
  return { from: madridDateAddDays(today, -59), to: today };
}
